import React from 'react';
import type { SetURLSearchParams } from 'react-router';
import type { Task } from '../../../api/tasks/interface';
import type { MentionInputHandle } from '../MentionInput';

// Consumes `?insert_mention=<id>` (+ optional `?insert_mention_label`) URL
// params: inserts the mention chip into the composer, removes the params,
// and focuses the input. `file:<id>` inserts a file mention; anything else is
// treated as a task id.
export function useUrlMentionInsertion(
  insertMention: string | null,
  insertMentionLabel: string | null,
  tasks: Task[],
  mentionInputRef: React.RefObject<MentionInputHandle>,
  setSearchParams: SetURLSearchParams
): void {
  React.useEffect(() => {
    if (!insertMention) {
      return;
    }
    if (insertMention.startsWith('file:')) {
      const fid = insertMention.slice(5);
      mentionInputRef.current?.insertMentionById(
        'file',
        fid,
        insertMentionLabel ?? fid
      );
    } else {
      const task = tasks.find((t) => t.id === insertMention);
      mentionInputRef.current?.insertMentionById(
        'task',
        insertMention,
        insertMentionLabel ?? task?.title ?? insertMention
      );
    }
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete('insert_mention');
      next.delete('insert_mention_label');
      return next;
    });
    setTimeout(() => mentionInputRef.current?.focus(), 50);
  }, [
    insertMention,
    insertMentionLabel,
    tasks,
    mentionInputRef,
    setSearchParams,
  ]);
}
